// extracted by mini-css-extract-plugin
export default {"pagination":"kh5h-","arrow":"_21ArB","page":"_3JQfF","active":"_3KtPQ"};